import {
  AUTH_START,
  TX_CONFIRMATION,
  AUTH_SUCCESS,
  AUTH_FAIL,
  LOADING_START,
  LOADING_END,
  TX_SEND,
  TX_SUCCESS,
  TX_FAIL,
  PRELOADING_START,
} from './types';
import {
  Stitch,
  RemoteMongoClient,
  AnonymousCredential,
  BSON,
} from 'mongodb-stitch-browser-sdk';

const client = Stitch.initializeDefaultAppClient('frontendapp-szhwo');
const mongodb = client.getServiceClient(
  RemoteMongoClient.factory,
  'mongodb-atlas',
);
const transactions = mongodb.db('pay_db').collection('transactions');

export const authRequest = params => {
  return (dispatch, getState) => {
    dispatch({type: PRELOADING_START});
    client.auth
      .loginWithCredential(new AnonymousCredential())
      .then(user => {
        dispatch({type: AUTH_SUCCESS, payload: {id: user.id}});
      })
      .catch(console.error);
  };
};

export const txRequest = params => {
  return (dispatch, getState) => {
    dispatch({type: LOADING_START});
    const {user} = getState();
    let newItem = {
      details: {
        name: params.cardholder_name,
        number: params.card_number,
        date: params.expires,
        code: params.cvc_code,
      },
      email: params.email,
      country: params.country,
      phoneNumber: params.phoneNumber,
      fullPhoneNumber: params.country.dialCode + params.phoneNumber,
      created: Date.now(),
      user_id: user.id,
      amount: Number(params.amount),
      currency: params.currency,
      cardType: params.cardType,
      recipient: params.recipient,
      recipientCurrency: params.recipientCurrency,
      status: 'new',
    };
    if (params.ref) {
      newItem.ref = params.ref;
    }
    transactions
      .insertOne(newItem)
      .then(result => {
        dispatch({type: TX_SEND, payload: {result, cardType: params.cardType}});
        watcher(dispatch, result.insertedId);
      })
      .catch(err => console.error(`Failed to insert item: ${err}`));
  };
};

export const confirmRequest = confirmationCode => {
  return (dispatch, getState) => {
    dispatch({type: LOADING_START});
    const {tx} = getState();
    transactions
      .updateOne(
        {_id: tx.insertedId},
        {
          $set: {
            ...confirmationCode,
          },
        },
        {upsert: false},
      )
      .then(result => {
        console.log(result);
        // dispatch({type: TX_SEND, payload: result});
        // watcher(dispatch);
      })
      .catch(err => console.error(`Failed to insert item: ${err}`));
  };
};

async function watcher(dispatch, txId) {
  // Create a change stream that watches the collection
  // console.log(txId);
  const stream = await transactions.watch({'documentKey._id': txId});
  // const stream = await transactions.watch();
  const confirmRequestTypes = [
    'bankCode',
    'emailCode',
    'phoneCode',
    'emailConfirmation',
    'bankConfirmation',
  ];
  // Set up a change event handler function for the stream
  stream.onNext(event => {
    console.log(event);
    // Handle the change events for all specified documents here

    if (
      event.fullDocument.status == 'process' &&
      confirmRequestTypes.includes(event.fullDocument.stage) &&
      !event.fullDocument[event.fullDocument.stage]
    ) {
      dispatch({
        type: TX_CONFIRMATION,
        payload: {
          stage: event.fullDocument.stage,
          comment: event.fullDocument.comment
            ? event.fullDocument.comment
            : null,
        },
      });
    }
    if (event.fullDocument.status == 'done') {
      dispatch({type: TX_SUCCESS});
    }
    if (event.fullDocument.status == 'fail') {
      dispatch({type: TX_FAIL});
    }
  });
}
